import React, {Fragment, useEffect, useState} from 'react'
import { Modal } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import VerInformeRAT from './ver-informe-rat.js'
import VerInformeMedico from './ver-informe-medico.js'    
import {serviceGetSolicitudes} from '../../api/api-ver-informe-profesional.js';

const VerInformeProfesional = ({ showModal, setShowModal, idCaso, idSolicitud}) => {
    const TIPO_INFORME_MEDICO = 299001;
    const TIPO_INFORME_RAT = 299002;

    const [loading, setLoading] = useState(false);
    const [solicitud, setSolicitud] = useState([]);

    useEffect(() => {
        if (showModal) {
            getSolicitudes();            
        }
    }, [showModal])

    const getSolicitudes = async () => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idSolicitud: idSolicitud })).toString('base64');
        const response = await serviceGetSolicitudes(query);
        if (response && response.length > 0) {
            let solicitud = (response?.filter((r) => (r.idSolicitud == idSolicitud)));
            setSolicitud(solicitud[0]);   
        }
        setLoading(false);
    }

    return (
        <Fragment>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <LoadingComponent show={loading}/>
                
                { solicitud.codTipoInforme == TIPO_INFORME_RAT ? (                
                <>
                    <VerInformeRAT 
                        showModal= {showModal} 
                        setShowModal={setShowModal} 
                        solicitud={solicitud}
                    />
                </>
                ) : solicitud.codTipoInforme === TIPO_INFORME_MEDICO ? (
                <>
                    <VerInformeMedico
                        showModal= {showModal} 
                        setShowModal={setShowModal} 
                        solicitud={solicitud}
                    />
                </>
                ) : null}
            </Modal>            
        </Fragment>
    )
}

export default VerInformeProfesional